package ir.yusefpasha.style

import com.varabyte.kobweb.compose.css.CSSTransition
import com.varabyte.kobweb.compose.ui.Modifier
import com.varabyte.kobweb.compose.ui.modifiers.color
import com.varabyte.kobweb.compose.ui.modifiers.transform
import com.varabyte.kobweb.compose.ui.modifiers.transition
import com.varabyte.kobweb.compose.ui.modifiers.width
import com.varabyte.kobweb.compose.ui.styleModifier
import com.varabyte.kobweb.silk.components.style.ComponentStyle
import com.varabyte.kobweb.silk.components.style.anyLink
import com.varabyte.kobweb.silk.components.style.hover
import ir.yusefpasha.models.Theme
import ir.yusefpasha.util.Constants
import org.jetbrains.compose.web.ExperimentalComposeWebApi
import org.jetbrains.compose.web.css.*

val NavigationItemStyle by ComponentStyle {
    anyLink {
        Modifier.color(Theme.Secondary.rgb).transition(CSSTransition(property = "color", duration = Constants.ANIMATION_DURATION))
    }
    base {
        Modifier.color(Theme.Secondary.rgb).transition(CSSTransition(property = "color", duration = Constants.ANIMATION_DURATION))
    }
    hover {
        Modifier.color(Theme.Primary.rgb).transition(CSSTransition(property = "color", duration = Constants.ANIMATION_DURATION))
    }
}

@OptIn(ExperimentalComposeWebApi::class)
val LogoStyle by ComponentStyle {
    base {
        Modifier.transform { rotate(0.deg) }.transition(CSSTransition(property = "transform", duration = Constants.ANIMATION_DURATION))
    }
    hover {
        Modifier.transform { rotate((-12).deg) }.transition(CSSTransition(property = "transform", duration = Constants.ANIMATION_DURATION))
    }
}

val SocialLinkStyle by ComponentStyle {
    base {
        Modifier.color(Theme.Gray.rgb).transition(CSSTransition(property = "transform", duration = Constants.ANIMATION_DURATION))
    }
    hover {
        Modifier.color(Theme.Primary.rgb).transition(CSSTransition(property = "transform", duration = Constants.ANIMATION_DURATION))
    }
}

val MainButtonStyle by ComponentStyle {
    base {
        Modifier.width(100.px).transition(CSSTransition(property = "width", duration = Constants.ANIMATION_DURATION))
    }
    hover {
        Modifier.width(120.px).transition(CSSTransition(property = "width", duration = Constants.ANIMATION_DURATION))
    }
}

@OptIn(ExperimentalComposeWebApi::class)
val MainImageStyle by ComponentStyle {
    base {
        Modifier
            .styleModifier {
                filter {
                    grayscale(100.percent)
                }
            }
            .transition(CSSTransition(property = "filter", duration = Constants.ANIMATION_DURATION))
    }
    hover {
        Modifier
            .styleModifier {
                filter {
                    grayscale(0.percent)
                }
            }
            .transition(CSSTransition(property = "filter", duration = Constants.ANIMATION_DURATION))
    }
}